import React, { useEffect, useState } from 'react';
import 'react-tagsinput/react-tagsinput.css';
import moment from 'moment';
import './AdminNotification.scss';
import {Table, TableBody } from '@material-ui/core';
import Spinner from '../Spinner/Spinner';
import SVLS_API from '../../api-services/svls-api';

type Notification = {
  active: boolean;
  allowedConfig: number;
  createdBy: string;
  dateCreated: Date;
  endTime: Date;
  houseId: number;
  id: number;
  lastUpdated: Date;
  message: string;
  startTime: Date;
  title: string;
  updatedBy: string;
};


const AdminNotification = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [notifications, setNotifications] = useState<Notification[]>([]);

  const fetchNotifications = async () => {
    const response = await SVLS_API.get('/catalog/v2/notifications/', {
      headers: {
        Authorization: sessionStorage.getItem('jwt_token'),
      },
      params: {
        type: 'ALL',
      }
    });
    setNotifications(response?.data);
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  return (
    <div className="reports-ctn hn-ctn w-100">
      <div className="admin-notification-ctn">
        <div className="admin-notification-content-ctn">
          <div className="tab-content">
            <div className="admin-notification-table-ctn">
              {loading ? (
                <Spinner />
              ) : (
                <div>
                  {notifications ? (
                    <Table className="admin-notification-table table-ctn">
                      <TableBody>
                        {notifications && notifications.length > 0 ? (
                          <>
                            {notifications.map((row, idx) => (
                              <>
                                {idx < 20 ? (
                                  <div className="notification-table-ctn">
                                    <div className='notification-header'>
                                      {moment(row.startTime).format('DD MMM')}
                                    </div>
                                    <div className="notification-list">
                                      <div className="notification-created">
                                        <div>{moment(row.startTime).format('DD:MMM')}</div>
                                        <div>{moment(row.startTime).format('HH:mm')}</div>
                                      </div>
                                      <div className="message-cell">
                                        {row.message}
                                        <div className="notification-title">{row.title}</div>
                                      </div>
                                      
                                    </div>

                                  </div>
                                ) : null}
                              </>
                            ))}
                          </>
                        ) : null}
                      </TableBody>
                    </Table>
                  ) : null}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminNotification;
